import { cn } from "@pdfking/components"

// Shared tailwind class recipes for the form fields — the shadcn-flavored
// equivalent of bootstrap's form-control/form-select/btn-outline set.

// `bg-card`, not `bg-transparent`, matching the vendored field components
// (see @pdfking/components cli/refresh.ts): on a translucent host a
// transparent field dissolves into whatever is behind the window — and this
// class lands on `NativeSelect` via `cn`, so a `bg-transparent` here would
// undo that component's own surface.
export const INPUT_CLASS =
  "flex h-8 w-full min-w-0 rounded-md border border-input bg-card px-2 py-1 text-sm shadow-xs transition-colors outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50"

export const INVALID_CLASS = "border-destructive focus-visible:ring-destructive/30"

/**
 * How far a field's trailing icon sits from its inner edge — the clear X on
 * `DjInput`, the caret on `DjSelect`. The two stand side by side in every form
 * row, so they have to agree; holding the value here is what keeps "nudge them
 * outward" a single edit instead of two that drift apart.
 *
 * `2` (0.5rem) is deliberately the same step as `INPUT_CLASS`'s `px-2`, so the
 * icon is inset exactly as far from the right edge as the text is from the
 * left, and matches what Bootstrap gives `.form-control-sm`.
 *
 * Two spellings because the mechanisms differ: the addon is laid out in flow
 * (padding), while the caret is absolutely positioned inside the vendored
 * `NativeSelect` and is reached through its `data-slot` rather than by editing
 * that file. Both are whole literals — Tailwind scans source text, so a
 * computed `pr-${n}` would never be generated.
 */
export const TRAILING_ICON_PADDING = "pr-2"
export const TRAILING_ICON_INSET = "[&_[data-slot=native-select-icon]]:right-2"

// `cn` (tailwind-merge) is required here: plain concatenation leaves both
// `border-input` and `border-destructive` in the class list, and Tailwind's
// CSS generation order — not DOM order — picks the winner.
export const input_class = (invalid?: unknown): string =>
  cn(INPUT_CLASS, invalid ? INVALID_CLASS : "")
